import type { ReactNode } from "react";

interface FormFieldLabelProps {
    label: string;
    children: ReactNode;
}

const FormFieldLabel = (props: FormFieldLabelProps) => {
    return (
        <div className="flex flex-col gap-xs w-full">
            <p className="text-l text-p6-grey-dark">{props.label}</p>
            {props.children}
        </div>
    );
};

export default FormFieldLabel;
